export const APP_VERSION_NAME = '_app_version';